import { useEffect, useState } from "react";

const InstitutionInfos = ({ selectedInstitution, setSelectedInstitution, setMapScreen }) => {
  const [scheduleState, setScheduleState] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    if (selectedInstitution) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [selectedInstitution]);

  useEffect(() => {
    if (selectedInstitution) {
      if (selectedInstitution.fullSchedule) {
        const schedule = Object.entries(selectedInstitution.fullSchedule);
        const displaySchedule = schedule.map((elt) => {
          const [day, hours] = elt;
          return (
            <div key={day}>
              <span> {day}</span> : <span>{hours}</span>
            </div>
          );
        });
        setScheduleState(displaySchedule);
      }
    }
  }, [selectedInstitution]);

  return (
    <>
      {selectedInstitution && (
        <div
          className={`institution-infos ${isActive ? "active" : ""} ${isFullScreen ? "fullscreen" : ""} ${
            process.env.REACT_APP_SIDEBAR === "right" ? "institution-infos--right" : ""
          }`}
        >
          <div className="mb-3">
            <img style={{ width: "300px", height: "auto" }} src={selectedInstitution.picture} alt="" />
          </div>
          <h4>{selectedInstitution.name}</h4>
          <div className="mb-3">{selectedInstitution.address}</div>
          <div className="mb-3">{scheduleState}</div>
          <a href={selectedInstitution.website}>
            <button>Découvrir le site</button>
          </a>
        </div>
      )}
    </>
  );
};

export default InstitutionInfos;
